export type ColorVariant = "primary" | "negative" | "positive" | "neutral";

export type VariantColors = {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
};

export const colors: Record<ColorVariant, VariantColors> = {
  primary: {
    50: "#FFF9F5",
    100: "#FFF4EB",
    200: "#FFE9D6",
    300: "#FFDDC2",
    400: "#FFD2AD",
    500: "#FFC799",
    600: "#CC9F7A",
    700: "#99775C",
    800: "#66503D",
    900: "#33281F",
  },
  negative: {
    50: "#FFEDED",
    100: "#FFDCDC",
    200: "#FFB8B8",
    300: "#FF9595",
    400: "#FF7171",
    500: "#FF4E4E",
    600: "#CC3E3E",
    700: "#B33737",
    800: "#802727",
    900: "#331010",
  },
  positive: {
    50: "#F0FBEF",
    100: "#E1F7DF",
    200: "#C2EFBE",
    300: "#A4E69E",
    400: "#85DE7D",
    500: "#67D65D",
    600: "#52AB4A",
    700: "#3E8038",
    800: "#295625",
    900: "#152B13",
  },
  neutral: {
    50: "#D0D0D0",
    100: "#B9B9B9",
    200: "#A1A1A1",
    300: "#8A8A8A",
    400: "#737373",
    500: "#5B5B5B",
    600: "#444444",
    700: "#2C2C2C",
    800: "#151515",
    900: "#0E0E0E",
  },
};

export const invariantColor = {
  white: "#FFFFFF",
  black: "#000000",
  transparent: "transparent",
};

export const radii = {
  2: 2,
  4: 4,
  8: 8,
};

export const animDuration = {
  100: "100ms",
  200: "200ms",
  300: "300ms",
  500: "500ms",
};
